import { PageComponentContext } from 'global/cnr/contexts/PageComponentContext'
import { useAppUserAccess } from 'global/cnr/contexts/useHelpers/useAppUserAccess'
import ItemMenuSquares from 'global/wrappers/ItemMenuSquares'
import { SportsDistrictContext } from 'projectSpecific/sports/cnr/contexts/SportsDistrictContext'
import { sportsShowTypes } from 'projectSpecific/sports/cnr/reducers/SportsSeasonReducer'
import { ModifyTeamMatches } from 'projectSpecific/sports/create/ModifyTeamMatches'
import RosterBuilder from 'projectSpecific/sports/create/RosterBuilder'
import TeamLinks from 'projectSpecific/sports/create/TeamLinks'
import React, { useContext, useMemo, useState } from 'react'
import { TeamMatchRoster } from './TeamMatchRoster'

const _teamInfoItems = {
  teamAccess: 'teamAccess',
  teamLinks: 'teamLinks',
  teamRoster: 'teamRoster',
  teamSchedule: 'teamSchedule',
  teamStaff: 'teamStaff',
  matchRoster: 'matchRoster'
}

export const TeamInfoSquares = ({ menuItems }) => {

  const appUserAccess = useAppUserAccess()
  const { isAdminOrSuper } = appUserAccess ?? {}

  const [selectedTeamItem, setSelectedTeamItem] = useState()

  const teamInfoItems = useMemo(() => {
    if (!isAdminOrSuper) {
      return _.omit(_teamInfoItems, [
        _teamInfoItems.teamAccess,
        _teamInfoItems.teamLinks,
        _teamInfoItems.teamSchedule,
        _teamInfoItems.teamStaff,
        _teamInfoItems.matchRoster,
      ])
    }
    return _teamInfoItems
  }, [isAdminOrSuper])

  const oc = (item) => {
    if (isAdminOrSuper) {
      setSelectedTeamItem(item)
    }
  }

  switch (selectedTeamItem) {
    case _teamInfoItems.teamRoster:
    case _teamInfoItems.teamStaff:
      return <RosterBuilder handleCancel={setSelectedTeamItem} />
    case _teamInfoItems.teamSchedule:
      return <ModifyTeamMatches handleCancel={setSelectedTeamItem} />
    case _teamInfoItems.teamLinks:
      return <TeamLinks />
    case _teamInfoItems.matchRoster:
      return <TeamMatchRoster handleCancel={setSelectedTeamItem} />
  }

  return <ItemMenuSquares
    caption={!isAdminOrSuper && <div style={{ padding: '1em' }}>Coming Soon</div>}
    menuItems={teamInfoItems}
    onClick={oc}
    iconItem={'arrow right'}
    fullRow={true}
  />

}
